// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__xp0L1"};